import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { ApiService } from 'src/app/shared/_service/api.service';

@Component({
	selector: 'app-configurazione-company',
	templateUrl: './configurazione-company.component.html',
})
export class ConfigurazioneCompanyComponent implements OnInit, OnDestroy {
	dtTrigger: Subject<any> = new Subject<any>();

	//TODO: ?
	// dtSettings: DataTables.Settings = {
	//     columnDefs: [
	//     ]
	// };

	listaCompany = [];

	constructor(private api: ApiService) {}

	ngOnInit(): void {
		this.api.getListaCompany().subscribe(
			(res) => {
				this.listaCompany = res;

				this.listaCompany.forEach((c) => {
					c.jsonIn = {};
					c.jsonIn.descrizione = c.descrizione;
					c.jsonIn.tipoOrdine = c.tipoOrdine;
					c.jsonIn.connettore = c.connettore;
					c.jsonIn.codice = c.codice;
					c.jsonIn.id = c.id ? c.id : null;
				});

				console.log(this.listaCompany);

				this.dtTrigger.next();
			},
			() => alert('Errore nel recupero delle company'),
		);
	}

	ngOnDestroy(): void {
		this.dtTrigger.unsubscribe();
	}

	salva(company: any) {
		//se metto un form si rompe tutto per qualche strano motivo
		if (company.jsonIn.descrizione === '' || company.jsonIn.connettore === '') {
			alert('Attenzione, compilare i campi "Descrizione" e "Connettore"');
			return;
		}

		company.jsonIn.cancellato = false;
		this.api.saveCompany(company.jsonIn).subscribe((res) => {
			if (res) {
				company.feEdit = false;
			} else {
				alert('non é stato possibile salvare la configurazione');
			}
		});
	}

	nuovaCompany() {
		const nuova = {
			feEdit: true,
			cancellato: false,
			id: null,
			jsonIn: {
				descrizione: '',
				connettore: '',
				codice: '',
				tipoOrdine: '',
			},
		};
		this.listaCompany.push(nuova);
	}
}
